import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useSetEventPanelModal } from '../event-panel-modals';

export function CopyCallMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const setEventPanelModal = useSetEventPanelModal();
    const handleSelect = (): void => {
        setEventPanelModal({
            type: 'COPY_CALL',
            props: {
                agencyEventId: clickParams.eventId,
            },
        });
    };

    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
